import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "searchInput",
    "subscribedSection",
    "checkedTitle",
    "uncheckedGroup",
    "checkedGroup",
    "navCount"
  ];

  static values = {
    key: String, // The section key (e.g., 'content', 'issuer', 'sector')
  };

  get uncheckedGroupController() {
    return this._getGroupController(this.uncheckedGroupTarget);
  }

  get checkedGroupController() {
    return this._getGroupController(this.checkedGroupTarget);
  }

  _getGroupController(target) {
    if (!target) return null;
    return this.application.getControllerForElementAndIdentifier(
      target,
      "user-tag-subscriptions--checkbox-group"
    );
  }

  connect() {
    this._bindEventHandlers();
  }

  _bindEventHandlers() {
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.handleLabelClick = this.handleLabelClick.bind(this);

    this.element
      .querySelectorAll(".subscription-checkbox")
      .forEach((checkboxInput) => {
        checkboxInput.addEventListener("change", this.handleCheckboxChange);
      });

    if (this.hasSearchInputTarget) {
      this.searchInputTarget.addEventListener("input", this.handleSearchInput);
    }

    this.element.querySelectorAll(".clickable-label").forEach((label) => {
      label.addEventListener("click", this.handleLabelClick);
    });
  }

  handleLabelClick(e) {
    const label = e.currentTarget;
    const checkbox = label.querySelector('input[type="checkbox"]');
    if (e.target !== checkbox && checkbox) {
      e.preventDefault();
      checkbox.checked = !checkbox.checked;
      const event = new Event("change", { bubbles: true });
      checkbox.dispatchEvent(event);
    }
  }

  handleCheckboxChange(event) {
    const checkboxInput = event.currentTarget;
    const checkboxDiv = checkboxInput.closest(".checkbox");
    const parentElement = checkboxDiv.parentElement;

    const sourceController = this._getGroupController(parentElement);
    let destinationController, destinationElement;

    if (checkboxInput.checked) {
      destinationElement = this.checkedGroupTarget;
      destinationController = this.checkedGroupController;
    } else {
      destinationElement = this.uncheckedGroupTarget;
      destinationController = this.uncheckedGroupController;
    }

    if (!sourceController || !destinationController || !destinationElement) {
      console.error("Could not find source or destination for checkbox move");
      return;
    }

    sourceController.removeItemElement(checkboxDiv);
    destinationElement.appendChild(checkboxDiv);
    destinationController.addItemElement(checkboxDiv);

    this._updateSectionTitle();
    this._toggleSubscribedSection();
  }

  handleSearchInput(event) {
    const input = event.currentTarget;
    const searchText = input.value;
    this.uncheckedGroupController?.filter(searchText);
  }

  checkAll() {
    const checkboxes = this.uncheckedGroupTarget.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = true;
      const event = new Event("change", { bubbles: true });
      checkbox.dispatchEvent(event);
    });
  }

  uncheckAll() {
    const checkboxes = this.checkedGroupTarget.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
      const event = new Event("change", { bubbles: true });
      checkbox.dispatchEvent(event);
    });
  }

  _toggleSubscribedSection() {
    if (!this.hasCheckedGroupTarget || !this.hasSubscribedSectionTarget) return;
    const checkedContainer = this.checkedGroupTarget;
    const subscribedSection = this.subscribedSectionTarget;
    const hasItems = (this.checkedGroupController?.items.length || 0) > 0;
    subscribedSection.classList.toggle("show", hasItems);
  }

  _updateSectionTitle() {
    if (!this.hasCheckedTitleTarget || !this.hasCheckedGroupTarget) return;
    const titleElement = this.checkedTitleTarget;
    const checkedCount = this.checkedGroupController?.items.length || 0;
    titleElement.textContent = `Subscribed (${checkedCount})`;
    
    // Update nav count
    if (this.hasNavCountTarget) {
      this.navCountTarget.textContent = checkedCount;
    }
    
    this._toggleSubscribedSection();
  }
}
